import React from "react";
import { graphql } from "gatsby";
import { HelmetDatoCms } from "../../plugins/gatsby-plugin-atollon";
import BlockRenderer from "../components/structured-text/block-renderer";
import { DraftDebug } from "../../plugins/gatsby-plugin-atollon";
const GreenwheatPage = ({ pageContext, data }) => {

    return (
        <>
            <DraftDebug publishedAt={data?.datoCmsGreenwheatPage?.meta?.publishedAt} />
            <HelmetDatoCms seo={data?.datoCmsGreenwheatPage?.seoMetaTags}>
                <body className={`page-template page-template--${data?.datoCmsGreenwheatPage?.slug === 'index' ? 'home' : data?.datoCmsGreenwheatPage?.slug}`} />
            </HelmetDatoCms>
            <BlockRenderer data={data?.datoCmsGreenwheatPage?.blocks} brand={`greenwheat`} />
        </>
    )
}

export const query = graphql`
    query GreenwheatPageTemplate ($originalId: String!) {
        datoCmsGreenwheatPage(originalId: { eq: $originalId }) {
            seoMetaTags {
                tags
            }
            jsonLd
            slug
            meta {
                publishedAt
            }
            blocks {
                __typename
                ...LandingBannerProps
                ...RecipeSelectorProps
                ...BasicCtaProps
                ...ThreeColumnItemProps
                ...RangeSliderItemProps
                ...TitleContentCategoryProps
                ...TitleHeaderProps
                ...ProductCtaProps
                ...RequestSampleProps
                ...ThankYouProps
            }
        }
    }
`
export default GreenwheatPage
